import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, NgZone, ChangeDetectorRef, AfterViewChecked, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from "@angular/router";
import { ApiService } from '../api.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { slideInAnimation } from '../animations/route-animation';
declare var $: any;
import Swal from 'sweetalert2';
import { MatSnackBar } from '@angular/material/snack-bar';
import { assignee_role_name, lead_role_name, noWhitespaceInRequiredValidator, password_validation } from '../shared/constants';
import { noop } from 'rxjs';
import { ChangePasswordFormComponent } from '../masters/users/change-password-form/change-password-form.component';

@Component({
	selector: 'app-navbar',
	templateUrl: './navbar.component.html',
	styleUrl: './navbar.component.scss',
	animations: [slideInAnimation]
})
export class NavbarComponent implements OnInit, AfterViewChecked {
	homeUrl = this.apiService.getHomeURL();
	user: any = null;
	userList: any[] = [];
	departmentList: any[] = [];
	userLoader = false;
	@ViewChild(ChangePasswordFormComponent) resetPasswordForm!: ChangePasswordFormComponent;

	constructor(private _snackBar: MatSnackBar, private changeRef: ChangeDetectorRef, private observer: BreakpointObserver, private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, private zone: NgZone) { }

	ngOnInit(): void {
		/* this.userLoader = true;
		this.apiService.getUserAndAllUsers().subscribe({
			next: (response: any) => {
				let data = response[0];
				let data1 = response[1];
				this.departmentList = response[2];
				if (!data.data.tms_access) {
					data.data.tms_access = {
						"create_task": false,
						"edit_task": false,
						"delete_task": false,
						"change_task_status": false,
						"finish_task": false,
						"task_excel": false,
						"create_recurring_task": false,
						"edit_recurring_task": false,
						"delete_recurring_task": false,
						"attendance_module": false,
						"regularization_module": false,
						"leave_module": false,
						"roster_module": false,
						"create_news": false,
						"edit_news": false,
						"delete_news": false,
						"create_holiday": false,
						"edit_holiday": false,
						"delete_holiday": false,
						"create_event": false,
						"edit_event": false,
						"delete_event": false
					}
				}
				this.user = data.data;
				this.userList = data1.data.map((u) => {
					try {
						u.full_name = u.first_name + " " + u.last_name;
					} catch (error) {
						u.full_name = u.first_name;
					}
					u.department_name = u.department_name || '---';
					return u;
				});
				const id_lst = this.userList.map((u) => u.id);
				const emp_code_lst = this.userList.map((u) => u.emp_code);
				const email_lst = this.userList.map((u) => u.email);
				id_lst.push(this.user.id);
				emp_code_lst.push(this.user.emp_code);
				email_lst.push(this.user.email);
				this.apiService.decryptMultiple([id_lst, emp_code_lst, email_lst]).subscribe({
					next: (res: any) => {
						const len1 = this.userList.length;
						this.user.dec_id = parseInt(res[0][len1]);
						this.user.dec_emp_code = res[1][len1];
						this.user.dec_email = res[2][len1];
						for (let i = 0; i < len1; i++) {
							this.userList[i].dec_id = parseInt(res[0][i]);
							this.userList[i].dec_emp_code = res[1][i];
							this.userList[i].dec_email = res[2][i];
							if (this.user.dec_id === this.userList[i].dec_id) {
								this.user.id = this.userList[i].id;
								this.user.emp_code = this.userList[i].emp_code;
								this.user.email = this.userList[i].email;
							}
						}
						this.apiService.setUserList(this.userList);
						this.apiService.setUserData(this.user);
						this.userLoader = false;
					}, error: (error) => {
						this.userLoader = false;
						this.user = null;
						this.userList = [];
						this.apiService.setUserData(this.user);
						this.apiService.setUserList(this.userList);
						this.toastr.error("Something went wrong", 'Error!', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}, error: (error) => {
				this.userLoader = false;
				this.user = null;
				this.userList = [];
				this.apiService.setUserData(this.user);
				this.apiService.setUserList(this.userList);
				this.toastr.error("Something went wrong", 'Error!', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		}); */
		this.userLoader = true;
		this.apiService.getUserAndAllUsers().subscribe({
			next: (response: any) => {
				let data = response[0];
				let data1 = response[1];
				this.departmentList = response[2] || [];

				if (!data.data.tms_access) {
					data.data.tms_access = {
						"create_task": false,
						"edit_task": false,
						"delete_task": false,
						"change_task_status": false,
						"finish_task": false,
						"task_excel": false,
						"create_recurring_task": false,
						"edit_recurring_task": false,
						"delete_recurring_task": false,
						"attendance_module": false,
						"regularization_module": false,
						"leave_module": false,
						"roster_module": false,
						"create_news": false,
						"edit_news": false,
						"delete_news": false,
						"create_holiday": false,
						"edit_holiday": false,
						"delete_holiday": false,
						"create_event": false,
						"edit_event": false,
						"delete_event": false
					};
				}
				this.user = data.data;

				// Process full name and defaults for user list
				let rawUserList = data1.data.map((u) => {
					try {
						u.full_name = u.first_name + " " + u.last_name;
					} catch (error) {
						u.full_name = u.first_name;
					}
					u.department_name = u.department_name || '---';
					return u;
				});

				// Apply department filtering logic for Lead and Assignee
				const userRole = this.user.role_name;
				const userDept = this.user.department;

				if ((userRole === lead_role_name || userRole === assignee_role_name) && userDept !== null && userDept !== undefined) {
					// Filter department list to match logged-in user's department ID
					this.departmentList = this.departmentList.filter(
						(dept: any) => Number(dept.id) === Number(userDept)
					);

					// Filter user list to match logged-in user's department
					this.userList = rawUserList.filter(
						(u: any) => u.department !== null && u.department !== undefined && Number(u.department) === Number(userDept)
					);
				} else {
					// Admin or users with null department get all data without filtering
					this.userList = rawUserList;
				}

				this.apiService.setDepartmentList(this.departmentList);

				const id_lst = this.userList.map((u) => u.id);
				const emp_code_lst = this.userList.map((u) => u.emp_code);
				const email_lst = this.userList.map((u) => u.email);
				id_lst.push(this.user.id);
				emp_code_lst.push(this.user.emp_code);
				email_lst.push(this.user.email);

				this.apiService.decryptMultiple([id_lst, emp_code_lst, email_lst]).subscribe({
					next: (res: any) => {
						const len1 = this.userList.length;
						this.user.dec_id = parseInt(res[0][len1]);
						this.user.dec_emp_code = res[1][len1];
						this.user.dec_email = res[2][len1];
						for (let i = 0; i < len1; i++) {
							this.userList[i].dec_id = parseInt(res[0][i]);
							this.userList[i].dec_emp_code = res[1][i];
							this.userList[i].dec_email = res[2][i];
							if (this.user.dec_id === this.userList[i].dec_id) {
								this.user.id = this.userList[i].id;
								this.user.emp_code = this.userList[i].emp_code;
								this.user.email = this.userList[i].email;
							}
						}
						this.apiService.setUserList(this.userList);
						this.apiService.setUserData(this.user);
						this.userLoader = false;
					}, error: (error) => {
						this.userLoader = false;
						this.user = null;
						this.userList = [];
						this.apiService.setUserData(this.user);
						this.apiService.setUserList(this.userList);
						this.toastr.error("Something went wrong", 'Error!', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}, error: (error) => {
				this.userLoader = false;
				this.user = null;
				this.userList = [];
				this.departmentList = [];
				this.apiService.setUserData(this.user);
				this.apiService.setUserList(this.userList);
				this.apiService.setDepartmentList(this.departmentList);
				this.toastr.error("Something went wrong", 'Error!', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	ngAfterViewChecked(): void {
		this.changeRef.detectChanges();
	}

	public hasAttendanceAccess() {
		try {
			return (
				this.user.tms_access?.attendance_module/*  &&
				this.user.role_name != assignee_role_name */
			)
		} catch (error) {
			return false;
		}
	}

	public hasRegularizationAccess() {
		try {
			return (
				this.user.tms_access?.regularization_module/*  &&
				this.user.role_name != assignee_role_name */
			)
		} catch (error) {
			return false;
		}
	}

	public hasLeaveAccess() {
		try {
			return (
				this.user.tms_access?.leave_module/*  &&
				this.user.role_name != assignee_role_name */
			)
		} catch (error) {
			return false;
		}
	}

	public hasRosterAccess() {
		try {
			return (
				this.user.tms_access?.roster_module/*  &&
				this.user.role_name != assignee_role_name */
			)
		} catch (error) {
			return false;
		}
	}

	public async getValueFromUserList(value: any, field) {
		try {
			let dec = await this.apiService.decryptAsync([value]);
			let emp = this.userList.find((u) => u["dec_" + field] == dec[0]);
			return emp[field];
		} catch (error) {
			return null;
		}
	}

	prepareRoute(outlet: RouterOutlet) {
		return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
	}

	logoutUser() {
		this.apiService.navigateToLogin(false);
	}

	openResetPasswordModal() {
		if (this.user && this.user.Email) {
			this.resetPasswordForm.username = this.user.Email;
			this.resetPasswordForm.openResetPasswordModal();
		} else {
			this.toastr.error("Something went wrong", 'Error!', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		}
	}

	scrollToTop() {
		let selector = "#page-content-container-common";
		try {
			$('html, body').animate({
				scrollTop: $(selector).offset().top - 70 + 'px'
			}, 'fast');
		} catch (error) { }
	}

	showScrollBtn = false;
	@HostListener('window:scroll', ['$event'])
	onScroll(e: any) {
		try {
			if ($('#main-menu-header').offset().top) {
				this.showScrollBtn = true;
			} else {
				this.showScrollBtn = false;
			}
		} catch (error) { }
	}
}
